<div
  ngbDropdown
  placement="bottom-right"
  *ngIf="user$ | async as _user"
  class="kt-header__topbar-item kt-header__topbar-item--user"
>
  <div ngbDropdownToggle class="kt-header__topbar-wrapper">
    <div class="kt-header__topbar-user" [ngClass]="{ 'kt-header__topbar-icon': icon }">
      <span class="kt-header__topbar-welcome kt-hidden-mobile" *ngIf="greeting"
        >{{ 'USER.GREETING' | transloco }},&nbsp;</span
      >
      <span class="kt-header__topbar-username kt-hidden-mobile" *ngIf="greeting">{{ _user.firstName }}</span>
      <i *ngIf="icon" class="flaticon2-user-outline-symbol"></i>

      <kt-user-avatar *ngIf="_user.avatar" [user]="_user"> </kt-user-avatar>

      <span *ngIf="!_user.avatar" class="kt-badge kt-badge--username kt-badge--lg kt-badge--rounded kt-badge--bold">
        {{ _user.firstName | firstLetter }}
      </span>
    </div>
  </div>

  <div
    ngbDropdownMenu
    class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl"
  >
    <!--begin: Head -->
    <div
      class="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
      style="background-image: url(./assets/media/misc/bg-1.jpg)"
    >
      <div class="kt-user-card__avatar">
        <kt-user-avatar *ngIf="_user.avatar" [user]="_user"> </kt-user-avatar>

        <span
          *ngIf="!_user.avatar"
          class="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-success kt-badge--username__inner"
        >
          {{ _user.firstName | firstLetter }}
        </span>
      </div>

      <div class="kt-user-card__name">
        {{ _user.firstName }}
      </div>
    </div>
    <!--end: Head -->

    <!--begin: Navigation -->
    <div class="kt-notification">
      <a routerLink="profile" [routerLink]="['/', 'profile']" class="kt-notification__item">
        <div class="kt-notification__item-icon">
          <i class="flaticon2-calendar-3"></i>
        </div>

        <div class="kt-notification__item-details">
          <div class="kt-notification__item-title kt-font-bold">
            {{ 'USER.PROFILE.MAIN' | transloco }}
          </div>

          <div class="kt-notification__item-time">
            {{ 'USER.PROFILE.SUBTITLE' | transloco }}
          </div>
        </div>
      </a>

      <div class="kt-notification__custom">
        <a
          *ngIf="isLoggedAsUser"
          [routerLink]="['/', 'auth', 'logout']"
          [queryParams]="{ loggedAsUser: true, redirectTo: router.url }"
          class="logout-btn btn btn-outline-brand btn-upper btn-sm btn-bold"
        >
          {{ 'AUTH.GENERAL.SIGNOUT_AS_USER_BUTTON' | transloco }}
        </a>

        <a [routerLink]="['/', 'auth', 'logout']" class="logout-btn btn btn-outline-brand btn-upper btn-sm btn-bold">
          {{ 'AUTH.GENERAL.SIGNOUT_BUTTON' | transloco }}
        </a>
      </div>
    </div>
    <!--end: Navigation -->
  </div>
</div>
